// A discount code at checkout and the till: the sale's lines as the code
// check wants them, and the code's saving as the per-line discounts the
// checkout maths already understands (so prices, VAT, commission and the
// saved sale all follow it, as they do a manual discount).
import { newServices } from '../../../_services/newservices.service';
import { loadTeam } from '../../onboarding/setup/data/stylist';

const round2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;

// Loaded once per location (signing out doesn't reload the app, so the
// caches are keyed by the active location)
const here = () => { try { return localStorage.getItem('salonId') || ''; } catch (e) { return ''; } };

// commonServiceId -> categoryId, from the menu
let catalog = null;
let catalogFor = null;
export const loadCategories = () => {
  if (!catalog || catalogFor !== here()) {
    catalogFor = here();
    catalog = newServices.listServices({}).then((res) => {
      const cats = (res && res.data && res.data.responseData && res.data.responseData.result) || [];
      const map = {};
      cats.forEach((c) => (c.serviceList || []).forEach((sv) => { map[String(sv.commonServiceId)] = String(c._id); }));
      return map;
    }).catch(() => { catalog = null; return {}; });
  }
  return catalog;
};

// Who on the team is self-employed (salon codes skip them until they agree)
let team = null;
let teamFor = null;
export const loadSelfEmployed = () => {
  if (!team || teamFor !== here()) {
    teamFor = here();
    team = loadTeam().then((rows) => (rows || [])
      .filter((r) => Number(r.hairdresserInfo && r.hairdresserInfo.employmentTypeId) === 2 && Number(r.hairdresserInfo && r.hairdresserInfo.isSalonOwner) !== 1)
      .map((r) => String(r._id)))
      .catch(() => { team = null; return []; });
  }
  return team;
};

export const tillLines = (items, categories = {}) => (items || []).map((it, i) => {
  const id = String(it.commonServiceId || it.serviceId || '');
  return {
    id: `l${i}`,
    // Gift cards being sold (and anything else) are never discounted
    kind: it.type === 'product' ? 'product' : (it.type === 'service' || !it.type) ? 'service' : String(it.type),
    serviceId: id,
    categoryId: categories[id] || null,
    stylistId: it.staffId ? String(it.staffId) : null,
    price: Number(it.originalPrice) || 0,
    qty: it.quantity || 1,
  };
});

// { [index]: { type, value } }: a percentage code as its percentage on each
// line it covers; a pound code as each line's share, per unit
export const lineDiscountsFrom = (code, result, items) => {
  const out = {};
  (result && result.lines ? result.lines : []).forEach((l) => {
    if (!l.eligible || !(Number(l.amount) > 0)) return;
    const i = Number(String(l.id).replace(/^l/, ''));
    const it = items[i];
    if (!it) return;
    const qty = it.quantity || 1;
    out[i] = code.type === 'percentage'
      ? { type: 'percentage', value: Number(code.value) }
      : { type: 'fixed', value: round2(Number(l.amount) / qty) };
  });
  return out;
};

// What's sent with the sale: the code and its saving per line
export const promoFor = (promo, items) => (promo ? {
  code: promo.code,
  codeId: promo.codeId || null,
  amount: promo.amount,
  lines: (promo.lines || []).map((l) => ({ index: l.index, serviceId: items[l.index] ? String(items[l.index].commonServiceId || items[l.index].serviceId || '') : '', listPrice: items[l.index] ? items[l.index].originalPrice : 0, discount: l.amount })),
} : null);

// Lines the code skipped because a self-employed stylist hasn't agreed, by name
export const skippedForConsent = (result, items) => [...new Set((result && result.lines ? result.lines : [])
  .filter((l) => l.why === 'consent')
  .map((l) => { const it = items[Number(String(l.id).replace(/^l/, ''))]; return it && (it.staffName || '').trim().split(/\s+/)[0]; })
  .filter(Boolean))];
